import { Modal } from '@shared/components/Modal';
import { i18n } from '@shared/util/i18n';
import { UrgentModalContent, UrgentModalContentProps } from './content';
import styles from './index.module.css';

export interface UrgentModalProps extends UrgentModalContentProps {
  visible: boolean;
}

export function UrgentModalComponent({ visible, ...contentProps }: UrgentModalProps) {
  return (
    <Modal
      mode="modal"
      isOpen={visible}
      onOpenChange={contentProps.onClose}
      testID="urgent-modal"
      className={styles.urgentModal}
    >
      <Modal.TitleBar
        title={i18n('chat.urgent.sendAsUrgent')}
        startContent={<Modal.CloseButton onClick={contentProps.onClose} />}
        showBorder={false}
      />
      <UrgentModalContent {...contentProps} />
    </Modal>
  );
}
